/**
 * How close to falling the player is, read from the health the server sends
 * them: nothing to say above a quarter, a warning under it, an urgent one
 * under a tenth, and nothing again once fallen (the death has its own scene).
 * Presentation only: it decides a vignette and a heartbeat, never a rule.
 */

export type LowHealthLevel = 'none' | 'low' | 'critical';

/** Under this share of the maximum, the warning starts. */
export const LOW_HEALTH_SHARE = 0.25;
/** Under this share, it beats faster. */
export const CRITICAL_HEALTH_SHARE = 0.1;

export function lowHealthLevel(hp: number, maxHp: number): LowHealthLevel {
  if (hp <= 0 || maxHp <= 0) return 'none';
  const share = hp / maxHp;
  if (share < CRITICAL_HEALTH_SHARE) return 'critical';
  if (share < LOW_HEALTH_SHARE) return 'low';
  return 'none';
}

/** The time between two heartbeats, a little quicker when it is urgent. */
export function heartbeatIntervalMs(level: Exclude<LowHealthLevel, 'none'>): number {
  return level === 'critical' ? 900 : 1200;
}
